export default __webpack_public_path__ + "static/media/phone-white.45f89bd6.svg";